export const downloadDocument = (data: File) => {
  const date = new Date().toLocaleDateString('en-GB').replaceAll('/', '-');
  const time = new Date().toTimeString().split(' ')[0];

  const mediaType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  const blob = new Blob([data], { type: mediaType });

  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = `User_Management_Download_${date}_${time}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
};
